module.exports = __webpack_public_path__ + "img/ywfz.274d127f.png";